<template>
    <div>
        <button
            type="button"
            class="main-btn w-100"
            @click="isSearchDialogOpened = true"
        >
            {{ $t('home.search_game') }}
        </button>

        <van-dialog
            v-model:show="isSearchDialogOpened"
            title="Search"
            :show-confirm-button="false"
            @close="newGames = []"
            class="games-search-dialog"
        >
            <template #title>
                <div class="position-relative p-0">
                    <h3 class="m-0 text-white">Search</h3>
                    <button
                        class="close-btn"
                        @click="isSearchDialogOpened = false"
                    >
                        <van-icon
                            name="close"
                            size="20px"
                            color="#fff"
                        />
                    </button>
                </div>
            </template>
            <div class="container-fluid">
                <div class="form-group my-4">
                    <input
                        v-model="name"
                        type="text"
                        class="text-center custom-input w-100"
                        :placeholder="$t('home.search_game')"
                    >
                </div>
                <div class="grid grid-cols-4">
                    <GameCard
                        v-for="(game, index) in newGames.length > 0 ? newGames : games"
                        :key="index"
                        :game="game"
                        :provider="$route.query.provider"
                        @click="gameInit(game)"
                    />
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import GameCard from './GameCard.vue';
import GameCardSkeleton from './GameCardSkeleton.vue';

export default {
    components: {
        GameCard,
        GameCardSkeleton
    },
    props: {
        games: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            isSearchDialogOpened: false,
            name: null,
            newGames: [],
        };
    },
    methods: {
        ...mapActions(['fetchUser']),

        async gameInit(game) {
            // console.log("GAME", game)
            try {
                this.$store.commit("setLoading", true);
                const authUser = await this.fetchUser();
                if (!authUser) {
                    this.$router.push("/auth/login");
                }

                let providerID = this.$route.query.provider;
                const res = await axios.get("/games/url",
                    {
                        params: {
                            gameID: game.gameID,
                            provider: providerID,
                        },
                        headers: {
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    }
                );

                window.open(res.data.data.gameUrl, "_self");

                this.$store.commit("setLoading", false);
            } catch (error) {
                this.$store.commit("setLoading", false);
            }
        },
    },
    watch: {
        name() {
            this.newGames = this.games.filter((game) => game.gameName.toLowerCase().includes(this.name.toLowerCase()));
        },
    },
    async mounted() {
    },
};
</script>
<style scoped>
.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    min-height: 200px;
}

/* Main button — purple gradient instead of blue */
.main-btn {
    border-radius: 20px;
    height: 30px;
    min-width: 6rem;
    text-align: center;
    box-shadow: none;
    background: linear-gradient(to right, #6d3bd9, #a78bfa);
    color: #fff;
    border: none;
    font-weight: 500;
    transition: all 0.3s ease;
}

.main-btn:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(167, 139, 250, 0.4);
}

/* Input — light purple background and white text */
.custom-input {
    box-shadow: none;
    border-radius: 4px;
    font-size: 1.2rem;
    padding: 0.5rem 1.2rem;
    border: none;
    color: #fff !important;
    background-color: #5c2eb8 !important;
    transition: all 0.3s ease;
}

.custom-input::placeholder {
    color: rgba(255, 255, 255, 0.7);
}

.custom-input:focus {
    outline: none;
    background-color: #6d3bd9 !important;
    box-shadow: 0 0 6px #a78bfa;
}

/* Dialog background */
.games-search-dialog {
    width: 100% !important;
    height: 100vh;
    inset: 0 !important;
    border-radius: 0;
    overflow-y: auto;
    transform: translate(0, 0);
    scrollbar-width: none;
    background: #3f1387;

    h3 {
        font-size: 1.2rem;
        color: #fff;
    }

    .close-btn {
        position: absolute;
        top: 0;
        right: 10px;
        background: transparent;
        border: none;
        cursor: pointer;
        transition: opacity 0.2s ease;
    }

    .close-btn:hover {
        opacity: 0.7;
    }
}
</style>
